import React, { useState } from 'react';
import Gratu from '../gratu';

import OKModal from '../modal';

import Page00 from '../../pages/page00';
import Page01 from '../../pages/page01';

import PageWithWords from '../../pages/page_w_words';
import PageWordsItog from '../../pages/page_words_itog';
import PageWordsEnd from '../../pages/page_words_end';

import PageWithRebus from '../../pages/page_w_rebus';
import PageRebusBegin from '../../pages/page_rebus_begin';
import PageRebusEnd from '../../pages/page_rebus_end';

import PageMoneyBegin from '../../pages/page_money_begin';
import PageWithMoney from '../../pages/page_w_money';
import PageMoneyEnd from '../../pages/page_money_end';

import PageWithFrauds from '../../pages/page_w_frauds';
import PageFraudsBegin from '../../pages/page_frauds_begin';

//import { YMInitializer } from 'react-yandex-metrika';
//import ym from 'react-yandex-metrika';

import './style.css';
import './app.css';

const audio = new Audio('');
const playSound = (sound) => {
  audio.src = `audio/${sound}.mp3`;

  audio.play();
};

// const setPlayerStop = () => {
//   audio.pause();
//   document.querySelector('.rhap_container audio').pause();
// };

  const pages = [
    { page: Page00, answer: '', info: true },
    { page: Page01, answer: '', info: true },

    { page: PageWithWords, answer: 'банкрот', info: false, props: ['Депозит','Вклад','Банкрот','Сбережения']},
    { page: PageWithWords, answer: 'юань', info: false, props: ['Вексель', 'Юань', 'Облигация', 'Акция']},
    { page: PageWithWords, answer: 'дресс-код', info: false, props: ['Банкомат', 'Банковская карта', 'Пин-код', 'Дресс-код']},
    { page: PageWithWords, answer: 'жетон', info: false, props: ['Евро', 'Жетон', 'Доллар', 'Рубль']},
    { page: PageWithWords, answer: 'e-mail', info: false, props: ['E-mail', 'Монета', 'Купюра', 'Банкнота']},
    { page: PageWithWords, answer: 'товар', info: false, props: ['Кредит', 'Товар', 'Ссуда', 'Ипотека']},
 
    { page: PageWordsItog, answer: 'бюджет', info: false },

    { page: PageWordsEnd, answer: '02info', info: true},
    { page: PageRebusBegin, answer: '02info', info: true },

    { page: PageWithRebus, answer: 'платёж', info: false, props: 'platezh'},
    { page: PageWithRebus, answer: 'банкнота', info: false, props: 'banknota'},
    { page: PageWithRebus, answer: 'монета', info: false, props: 'moneta'},
    { page: PageWithRebus, answer: 'перевод', info: false, props: 'perevod'},
    { page: PageWithRebus, answer: 'вексель', info: false, props: 'veksel'},

    { page: PageRebusEnd, answer: '02info', info: true },
    
    { page: PageMoneyBegin, answer: '02info', info: true },
    { page: PageWithMoney, answer: '200', info: false, props: '200' },
    { page: PageWithMoney, answer: '1000', info: false, props: '1000' },
    { page: PageWithMoney, answer: '5000', info: false, props: '5000' },
    { page: PageWithMoney, answer: '2000', info: false, props: '2000' },
    { page: PageWithMoney, answer: '500', info: false, props: '500' },
    { page: PageMoneyEnd, answer: '02info', info: true },
    
    { page: PageFraudsBegin, answer: '02info', info: true},
    { page: PageWithFrauds, answer: '2', info: false},
      
    
  ];

  const maxPage = pages.length - 1;
  let messNext = 'Дальше';
  let img="images/finik_10.png";
  let caption = "Молодец, правильно";
    
const App = () => {
  const [currentPage, setCurrentPage] = useState(0);
  const [answer, setAnswer] = useState(''); 
  const [show, setShow] = useState(false);
  const [successModal, setSuccess] = useState(false);
  
  const incCurrentPage = () => setCurrentPage(currentPage + 1);

  const openModal = (success) => {
      if( success) setSuccess(true);
      else setSuccess(false);
      setShow(true);
  };

  const closeModal = () => {
    setShow(false);
    if( successModal) incCurrentPage();
  };
  
  const onBegin = () => {
    audio.pause();
    playSound('nextlevel');
    setCurrentPage(0);
    setShow(false);
  };

  const onNextLevel = (ans) => {
    // console.log('answer=', answer, "ans=", ans);
    audio.pause();
    const forver = typeof ans === 'string' ? ans : answer;
    // console.log(forver, ans, answer);

    if( pages[currentPage].info) {
      incCurrentPage();
      // playSound('nextLevel'); ???????????????
    } else
    if( forver && pages[currentPage].answer.trim().toLowerCase() === forver.trim().toLowerCase()) {
      playSound('success'); //????

      // setCurrentPage(currentPage + 1);
//  incCurrentPage();
      if(ans) {
        openModal(true); // ok
      }

    } else {
      playSound('error');
      openModal();
// mess wrong answer? please repeat
    }
    setAnswer('');

    if (currentPage < maxPage) {
      // playSound('nextlevel');
    } else {
      // playSound('fire');
    }

  };

  if ( currentPage > maxPage) {
    playSound('z_uki-ura-detskoe');
//    ym('reachGoal','gratu');
    // ym(70605526,'reachGoal','gratu');

    return (
      <Gratu onBegin={onBegin}/>
    );
  }
  
  const CurPage = pages[currentPage].page;
  const props = pages[currentPage].props?pages[currentPage].props:null;

  if( successModal) {
    messNext = 'Дальше';
    img="images/finik_11.png";
    caption = "Молодец, правильно";
  
  } else {    
    caption = "Подумай и выбери другой ответ";
    messNext = 'Продолжим';
    img="images/finik_10.png";
  }
//   <YMInitializer accounts={[70605526]} />

  return <>
    <OKModal {...{show, closeModal, caption, messNext, img}}/>
    <CurPage 
      onNextLevel={onNextLevel}
      messNext={messNext} 
      answer={answer} 
      setAnswer={setAnswer}
      props={props}
    />
  </>;

};

export default App;
